import { Box, Grid, TextField } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { isNumber } from "highcharts";
import React, { useState } from "react";
import { useDispatch } from "react-redux";

const YearPicker = ({ setYear, index, yearFrom, yearTo, defValue }) => {
  console.log("INDEX: ", index)
  console.log("default value: ", defValue)
  console.log("setYear: ", setYear)
  const dispatch = useDispatch();
  const [selectedYear, setSelectedYear] = useState(() => {
    console.log("defValue: ", defValue)
    console.log("index: ", index)
    if (defValue) {
      dispatch(setYear(index !== undefined ? { index: index, short: defValue } : defValue));
      return new Date(defValue, 0);
    }
    return null;
  });

  const handleYearChange = (newValue) => {
    console.log("new value:", newValue)
    if (newValue !== null) {
      const selectedDate = new Date(newValue);
      console.log("selected date:", selectedDate)
      const selectYear = selectedDate.getFullYear();
      console.log("selected year:", selectYear)
      setSelectedYear(new Date(selectYear, 0, 1));
      dispatch(setYear(index !== undefined ? { index: index, short: selectYear } : selectYear));
    }
  };

  return (
    <Box display="flex" justifyContent="start" style={{ width: "100%" }}>
      <Grid
        style={{ width: "100%" }}
        justifyContent={"start"}
        display={"flex"}
        flexDirection={"row"}
        textAlign={"start"}
        width={"100%"}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs} style={{ width: "100%" }}>
          <DatePicker
            style={{ width: "100%" }}
            views={["year"]}
            label="Year"
            value={selectedYear}
            onChange={handleYearChange}
            minDate={new Date(yearFrom, 0)} // Set minimum date to January of yearFrom
            maxDate={new Date(yearTo, 11)} // Set maximum date to December of yearTo
            renderInput={(params) => (
              <TextField style={{ width: "100%" }} {...params} size="small" helperText={null} />
            )}
          />
        </LocalizationProvider>
      </Grid>
    </Box>
  );
};

export default YearPicker;